import { useMemo, useRef } from "react";
import {
  Filter,
  FilterCriteria,
  GenericFilter,
} from "data/@types/GlobalSearchData";
import { AdvancedViewFilterObject } from "data/store/global-search/AdvancedViewFiltersStore";
import { buildGenericFilter } from "./filterBuilders";

// Computes FilterCriteria from active filter state and returns a stable reference
// so downstream effects don't fire when store reference changes but content is the same.
export const useStableFilterCriteria = (
  meetingFilters: Filter[],
  activeFilters: AdvancedViewFilterObject,
): FilterCriteria | undefined => {
  const ref = useRef<FilterCriteria | undefined>(undefined);

  const next = useMemo((): FilterCriteria | undefined => {
    const filters: GenericFilter[] = meetingFilters.flatMap((fm) => {
      const filter = buildGenericFilter(fm, activeFilters[fm.label]);
      return filter ? [filter] : [];
    });
    return filters.length > 0 ? { filters } : undefined;
  }, [meetingFilters, activeFilters]);

  if (JSON.stringify(next) !== JSON.stringify(ref.current)) {
    ref.current = next;
  }

  return ref.current;
};
